import { type Surface } from '../../common/types';
import { buildCombinedKey } from '../buildCombinedKey';

type ModuleLocation = [id: string, path: string];

type Module = Surface;

type GetModulePaths = (
	outputMap: Map<ModuleLocation[0], ModuleLocation[1]>,
	module: Module,
	currentPath?: string[],
) => void;

export const populateModulePaths: GetModulePaths = (outputMap, module, currentPath = []) => {
	if (module.key && module.type) {
		outputMap.set(buildCombinedKey(module.type, module.key), currentPath.join('.'));
	}

	if (module.zones) {
		Object.entries(module.zones).forEach(([zoneKey, value]) => {
			value.forEach((m, i) => {
				if (m.data) {
					populateModulePaths(outputMap, m.data, [...currentPath, `zones.${zoneKey}[${i}].data`]);
				}
			});
		});
	}
};

export const getModulePathsInSurface = <S extends Surface>(surface: S) => {
	const outputMap = new Map<string, string>();

	populateModulePaths(outputMap, surface);

	return outputMap;
};
